var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useReducer, } from "@wordpress/element";
import { getAssignedTasksRequest } from "../api/user-page-api";
import { SET_ASSIGNED_TASKS, SET_ASSIGNED_TASKS_LOADING } from "../constants";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { reducer } from "../reducers/user-assigned-tasks-reducer";
import { UserPageAppContext } from "./UserPageAppContextProvider";
const initialState = {
    loading: true,
    assignedTasks: [],
};
const UserAssignedTasksContext = createContext({
    state: initialState,
    userAssignedTasksDispatch: () => { },
    loadAssignedTasks: () => { },
});
const UserAssignedTasksContextProvider = ({ children, }) => {
    const [state, userAssignedTasksDispatch] = useReducer(reducer, initialState);
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    useEffect(() => {
        loadAssignedTasks();
    }, [pageHash]);
    const loadAssignedTasks = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            userAssignedTasksDispatch({
                type: SET_ASSIGNED_TASKS_LOADING,
                payload: true,
            });
            const response = yield getAssignedTasksRequest(pageHash);
            userAssignedTasksDispatch({
                type: SET_ASSIGNED_TASKS,
                payload: response.data,
            });
        }
        catch (error) {
            handleError(error);
        }
        finally {
            userAssignedTasksDispatch({
                type: SET_ASSIGNED_TASKS_LOADING,
                payload: false,
            });
        }
    });
    return (_jsx(UserAssignedTasksContext.Provider, { value: { state, userAssignedTasksDispatch, loadAssignedTasks }, children: children }));
};
export { UserAssignedTasksContext, UserAssignedTasksContextProvider, };
